import "./EnterpriseOffer.module.css";
import Header from "@/reusable_sections/Header";
import SubscriptionPlans from "./sections/SubscriptionPlans";
import LivraisonSimpleEtTransparente from "./sections/LivraisonSimpleEtTransparente";
import OurClients from "./sections/OurClients";
import BoutiqueDecouvrirAcheter from "./sections/BoutiqueDecouvrirAcheter";
import FaqTransparenceDesPrix from "./sections/FaqTransparenceDesPrix";
export default function EnterpriseOfferPage() {
  return <div>
      <Header />
      <SubscriptionPlans />
      <LivraisonSimpleEtTransparente />
      <OurClients />
      <BoutiqueDecouvrirAcheter />
      <FaqTransparenceDesPrix />
    </div>;
}